import React from 'react';
import { prop } from 'ramda';
import { LocalPopup } from 'js/components/common/Popup';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';
import { getCleanUrl } from 'js/utils/url.util';
import { useDeviceSelector } from 'js/store/hooks';
import { useNavigateFromRegister } from './useNavigateFromRegister';
import { Layout } from '../Layout/Layout';
import { getRootClassNames } from 'js/components/system/Page/helpers';

import style from './PagePopup.scss';

export const PagePopup = ({ page, isLoading }) => {
    const cleanUrl = getCleanUrl();
    const isMobile = useDeviceSelector(prop('isMobile'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const isRegisterPage = cleanUrl === '/register';
    const isRegisterMobile = isMobile && isRegisterPage;
    const isRegisterDesktop = !isMobile && isRegisterPage;
    const targetBanner = document.getElementById('target_selector');
    const swissWrapper = document.querySelector('#target_selector .swiper-wrapper');
    const emptyDyBanner = targetBanner && swissWrapper && swissWrapper.childElementCount === 0;
    const navigateFromRegister = useNavigateFromRegister();

    const { isShowAsModal = false } = page;
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const { popupWidth, popupWidthUnit, hidePopUpTitle, title, rootClassNames } = page;

    return (
        <LocalPopup
            isModal={isShowAsModal}
            onClose={isRegisterPage && emptyDyBanner ? navigateFromRegister : navigateToPopupBackgroundPage}
            style={{ width: `${cleanUrl === '/register' && isDesktop ? `${popupWidth - 2}${popupWidthUnit}` : `${popupWidth}${popupWidthUnit}`}`, height: `${cleanUrl === '/register' && isMobile ? '100%' : 'auto'}` }}
            title={hidePopUpTitle ? undefined : title}
            className={`${isRegisterMobile ? `${style.registrationMobileContainer}` : isRegisterDesktop ? `${style.registrationDesktopContainer}` : `${style.container}`} ${getRootClassNames(rootClassNames).join(' ')}`}
        >
            <Layout page={page} isPageInPopup isLoading={isLoading}/>
        </LocalPopup>
    );
};
